let arr = [
  {
    sysLanguageId: 7,
    sysLanguageCode: "en_GB",
    sysLanguageName: "English",
  },
  {
    sysLanguageId: 9,
    sysLanguageCode: "es_ES",
    sysLanguageName: "Español",
  },
  {
    sysLanguageId: 14,
    sysLanguageCode: "fr_FR",
    sysLanguageName: "Français",
  },
  {
    sysLanguageId: 24,
    sysLanguageCode: "pt_PT",
    sysLanguageName: "Português",
  },
  {
    sysLanguageId: 34,
    sysLanguageCode: "zh_CN",
    sysLanguageName: "简体中文",
  },
  {
    sysLanguageId: 35,
    sysLanguageCode: "zh_TW",
    sysLanguageName: "繁体中文",
  },
  {
    sysLanguageId: 36,
    sysLanguageCode: "id_ID",
    sysLanguageName: "Bahasa Indonesia",
  },
  {
    sysLanguageId: 37,
    sysLanguageCode: "de_DE",
    sysLanguageName: "Deutsch",
  },
  {
    sysLanguageId: 38,
    sysLanguageCode: "it_IT",
    sysLanguageName: "Italiano",
  },
  {
    sysLanguageId: 39,
    sysLanguageCode: "pl_PL",
    sysLanguageName: "Polski",
  },
  {
    sysLanguageId: 40,
    sysLanguageCode: "ru_RU",
    sysLanguageName: "Русский",
  },
  {
    sysLanguageId: 41,
    sysLanguageCode: "vi_VN",
    sysLanguageName: "Tiếng Việt",
  },
  {
    sysLanguageId: 42,
    sysLanguageCode: "th_TH",
    sysLanguageName: "ไทย",
  },
  {
    sysLanguageId: 43,
    sysLanguageCode: "ar_SA",
    sysLanguageName: "العربية",
  },
  {
    sysLanguageId: 44,
    sysLanguageCode: "ja_JP",
    sysLanguageName: "日本語",
  },
  {
    sysLanguageId: 45,
    sysLanguageCode: "ko_KR",
    sysLanguageName: "한국어",
  },
  {
    sysLanguageId: 46,
    sysLanguageCode: "my_MM",
    sysLanguageName: "မြန်မာဘာသာ",
  },
  {
    sysLanguageId: 47,
    sysLanguageCode: "km_KH",
    sysLanguageName: "ភាសាខ្មែរ",
  },
]
export default arr;

const BROWSER_LANG_MAP = {
  ar: "ar_SA",
  de: "de_DE",
  en: "en_GB",
  es: "es_ES",
  fr: "fr_FR",
  it: "it_IT",
  ja: "ja_JP",
  ko: "ko_KR",
  pl: "pl_PL",
  th: "th_TH",
  ru: "ru_RU",
  vi: "vi_VN",
  zh: "zh_CN",
  id: "id_ID",
  pt: "pt_PT",
};

export function isSupportedLang(code) {
  return arr.some((item) => item.sysLanguageCode === code);
}

export function resolveSupportedLang(query, fallback = "en_GB") {
  if (isSupportedLang(query)) {
    return query;
  }
  return fallback;
}

export function getLangIndexByCode(code) {
  const index = arr.findIndex((item) => item.sysLanguageCode === code);
  return index >= 0 ? index : 0;
}

export function normalizeLangIndex(index) {
  const n = Number(index);
  if (!Number.isInteger(n) || n < 0 || n >= arr.length) {
    return 0;
  }
  return n;
}

function resolveDefaultLang() {
  const stored = localStorage.getItem("lang");
  if (isSupportedLang(stored)) {
    return stored;
  }
  const browserPrefix = (navigator.language || "").substring(0, 2);
  const mapped = BROWSER_LANG_MAP[browserPrefix];
  return isSupportedLang(mapped) ? mapped : "en_GB";
}

export const langDefault = resolveDefaultLang();